import Cookies from 'js-cookie';

class CookiePopup {
	constructor() {
		//this.setDefaultConsent(); // Call this as the first line in the constructor
		// load templates
		this.cookieNoticeTemplate = document.querySelector( '[data-b2c-notice-template]' );
		if ( ! this.cookieNoticeTemplate ) {
			return;
		}
		document.body.append( this.cookieNoticeTemplate.content.cloneNode( true ) );

		//console.log("b2Cookies: Loaded");
		this.reviewButton = document.querySelector( '.b2c-settings-button' );
		this.cookieSettings = document.querySelector( '.b2c-settings' );
		this.cookieSettingsInner = '.b2c-settings-inner';
		this.cookiePopup = document.querySelector( '.b2c-popup' );
		this.cookiePopupInner = '.b2c-popup-inner';
		this.acceptAllButton = document.querySelectorAll( '.b2c-accept-button' );
		this.rejectAllButton = document.querySelectorAll( '.b2c-reject-button' );
		this.cookiePopupClose = document.querySelector( '.b2c-popup-close-button' );
		this.closeButton = document.querySelector( '.b2c-settings .b2c-close-button' );
		this.cookieOptions = document.querySelectorAll( '.b2c-checkbox' );
		this.acceptSelectedButton = document.querySelectorAll( '.b2c-accept-selected' );
		this.cookiePopupDescription = document.querySelector( '.b2c-popup-description' );
		this.cookieLink = '#cookie-preferences';
		this.cookiePrefix = 'cookieconsent_';
		this.cookieName = 'cookie_consent';
		this.expires = 365;
		this.showPopup = true;
		this.triggered = [];
		this.all = [];

		// EVENTS
		this.events = [];
		this.eventCallbacks = [];
		this.triggeredEvents = [];
		// END EVENTS

		for ( const checkbox of this.cookieOptions ) {
			this.all.push( checkbox.getAttribute( 'name' ) );
		}

		const cookies = Cookies.get( this.cookieName );
		if ( this.hasCookies( cookies ) ) {
			const parsed = JSON.parse( cookies );
			this.showPopup = false;
			const cookieObj = [];
			for ( const [ cookie, value ] of Object.entries( parsed ) ) {
				if ( value ) {
					this.accept( cookie );
					cookieObj.push( cookie );
				}
			}
			this.sendCookies( cookieObj );
		} else {
			// this.googleConsent( [ 'preferences' ], false );
			Cookies.remove( this.cookieName );
		}

		if ( this.cookieSettings ) {
			this.cookieSettings.addEventListener( 'click', ( e ) => {
				if ( ! e.target.closest( this.cookieSettingsInner ) ) {
					e.preventDefault();
					this.hideSettings();
				}
			} );
		}

		if ( this.closeButton ) {
			this.closeButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.hideSettings();
			} );
		}

		if ( this.cookiePopup ) {
			this.cookiePopup.addEventListener( 'click', ( e ) => {
				if ( ! e.target.closest( this.cookiePopupInner ) ) {
					if ( window?.b2CookieNoticeSettings?.allowDismiss !== true ) {
						return;
					}

					e.preventDefault();
					this.hidePopup();
				}
			} );
		}

		if ( this.cookiePopupClose ) {
			this.cookiePopupClose.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.hidePopup();
			} );
		}

		if ( this.reviewButton && this.cookieSettings ) {
			this.reviewButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.showSettings();
			} );
		}

		for ( const accept of this.acceptAllButton ) {
			accept.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.acceptAll();
				this.closeAll();
			} );
		}
		for ( const accept of this.rejectAllButton ) {
			accept.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.rejectAll();
				setTimeout( ( e ) => {
					this.closeAll();
				}, 250 );
			} );
		}
		for ( const accept of this.acceptSelectedButton ) {
			accept.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.acceptSelected();
				this.closeAll();
			} );
		}

		// setup cookie options link
		document.addEventListener( 'click', ( e ) => {
			if ( 'href' in e.target ) {
				if ( e.target.href.includes( this.cookieLink ) ) {
					e.preventDefault();
					this.showPopup = true;
					this.show();
				}
			}
		} );

		// toggle description read more
		if ( this.cookiePopupDescription ) {
			const height = this.cookiePopupDescription.getBoundingClientRect().height;
			const lineHeight = parseInt( document.defaultView.getComputedStyle( this.cookiePopupDescription, null ).getPropertyValue( 'line-height' ).replace( 'px', '' ) );
			const lines = Math.floor( height / lineHeight );

			// only if more than three lines hide
			if ( lines > 3 ) {
				const closeHeight = height / lines * 3;
				this.cookiePopupDescription.height = height + 'px';
				this.cookiePopupDescription.closeHeight = closeHeight + 'px';
				this.cookiePopupDescription.style.height = closeHeight + 'px';
				const readMoreText = this.cookiePopupDescription.dataset.more;
				const readLessText = this.cookiePopupDescription.dataset.less;

				const readMore = document.createElement( 'a' );
				readMore.innerText = readMoreText;
				this.cookiePopupDescription.parentNode.append( readMore );

				readMore.addEventListener( 'click', ( e ) => {
					if ( this.cookiePopupDescription.classList.contains( 'b2c-open' ) ) {
						this.cookiePopupDescription.style.height = this.cookiePopupDescription.closeHeight;
						readMore.innerText = readMoreText;
					} else {
						this.cookiePopupDescription.style.height = this.cookiePopupDescription.height;
						readMore.innerText = readLessText;
					}
					this.cookiePopupDescription.classList.toggle( 'b2c-open' );
				} );
			}
		}

		setTimeout( ( e ) => {
			this.setupAccordion();
		}, 1000 );
	}

	// EVENTS
	// ------
	on( event, callback ) {
		if ( event in this.events ) {
			this.events[ event ].push( callback );
		} else {
			this.events[ event ] = [ callback ];
		}

		if ( this.triggeredEvents.includes( event ) ) {
			this.trigger( event );
		}
	}

	trigger( event, payload ) {
		if ( ! this.triggeredEvents.includes( event ) ) {
			this.triggeredEvents.push( event );
		}

		// ensure payload is an array
		if ( event in this.events ) {
			for ( const callback of this.events[ event ] ) {
				callback( payload );
			}
		}
	}
	// END EVENTS

	// LOAD SCRIPT
	// -----------
	loadScript( src ) {
		const script = document.createElement( 'script' );
		script.type = 'text/javascript';
		script.src = src;
		const head = document.querySelector( 'head' );
		head.append( script );
	}

	loadInlineScript( js ) {
		const script = document.createElement( 'script' );
		script.type = 'text/javascript';
		script.innerText = js;
		const head = document.querySelector( 'head' );
		head.append( script );
	}

	acceptAll() {
		for ( const cookie of this.all ) {
			this.accept( cookie );
		}
		this.setCookies( this.all );
		// Push the consentGiven event to the data layer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( { event: 'consentGiven', consent: 'accepted all' } );
	}

	rejectAll() {
		this.setCookies( [ 'preferences' ] );
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( { event: 'consentGiven', consent: 'rejected all' } );
	}

	acceptSelected() {
		const cookies = [];
		for ( const checkbox of this.cookieOptions ) {
			if ( checkbox.checked ) {
				cookies.push( checkbox.name );
				this.accept( checkbox.name );
			}
		}
		this.setCookies( cookies );
		// Push the event with details about selected cookies
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( { event: 'consentGiven', consent: 'accepted selected', selectedCookies: cookies } );
	}

	pushEvent() {
		//console.log('dataLayer', arguments);
		if ( 'dataLayer' in window ) {
			window.dataLayer.push( arguments );
		}
	}

	accept( cookie ) {
		if ( ! this.triggered.includes( cookie ) ) {
			this.pushEvent( {
				event: this.cookiePrefix + cookie,
			} );
			this.triggered.push( cookie );
			this.trigger( cookie );
		}
	}

	isValidJSON( str ) {
		try {
			return ( JSON.parse( str ) && !! str );
		} catch ( e ) {
			return false;
		}
	}

	hasCookies( cookies ) {
		if ( cookies ) {
			if ( this.isValidJSON( cookies ) ) {
				const parsed = JSON.parse( cookies );
				for ( const item of this.all ) {
					if ( ! ( item in parsed ) ) {
						return false;
					}
				}
				return true;
			}
		}
		return false;
	}

	setCookies( cookies = [] ) {
		const value = {};
		for ( const cookie of this.all ) {
			value[ cookie ] = cookies.includes( cookie );
			if ( ! value[ cookie ] ) {
				for ( const checkbox of this.cookieOptions ) {
					if ( checkbox.name === cookie ) {
						checkbox.checked = false;
					}
				}
			}
		}

		this.googleConsent( cookies );

		Cookies.set( this.cookieName, JSON.stringify( value ), {
			expires: this.expires,
		} );
	}

	sendCookies( cookies ) {
		for ( const cookie of cookies ) {
			this.accept( cookie );
		}

		this.googleConsent( cookies );
	}
	googleConsent( cookies, isUpdate = true ) {
		const googleData = {
			wait_for_update: 500,
		};

		// load analytics by default
		const loadAnalytics = window?.b2CookieNoticeSettings?.loadAnalytics;

		// Mapping your cookie types to Google consent types
		const cookieBinding = {
			ad_storage: 'marketing',
			analytics_storage: loadAnalytics ? 'preferences' : 'statistics',
			functionality_storage: 'preferences',
			personalization_storage: 'marketing',
			security_storage: 'preferences',
			ad_personalization: 'marketing',
			ad_user_data: 'marketing',
		};

		//Unnecessary to set all to 'denied' as default, set in b2-cookie-notice.php
		// Set default to 'denied'
		Object.keys( cookieBinding ).forEach( ( key ) => googleData[ key ] = 'denied' );

		// Update based on selected cookies
		for ( const [ googleKey, cookieKey ] of Object.entries( cookieBinding ) ) {
			if ( cookies.includes( cookieKey ) ) {
				googleData[ googleKey ] = 'granted';
			}
		}

		const type = 'update';
		this.pushEvent( 'consent', type, googleData );
		console.log( 'consent', type, googleData );
	}

	show() {
		if ( this.showPopup ) {
			document.documentElement.classList.add( 'b2c-popup-active' );
		}
	}

	hidePopup() {
		if ( this.showPopup ) {
			document.documentElement.classList.remove( 'b2c-popup-active' );
		}
	}

	setupAccordion() {
		// accordion
		const accordions = document.querySelectorAll( '.b2c-accordion' );
		for ( const accordion of accordions ) {
			const toggle = accordion.querySelector( '.b2c-accordion-toggle' );
			const content = accordion.querySelector( '.b2c-accordion-content' );
			const height = content.firstElementChild.getBoundingClientRect().height;

			if ( content && toggle ) {
				accordion.classList.add( 'b2c-collapsed' );
				content.style.setProperty( '--open-height', height + 'px' );
				toggle.addEventListener( 'click', ( e ) => {
					accordion.classList.toggle( 'b2c-collapsed' );
				} );
			}
		}
	}

	showSettings() {
		document.documentElement.classList.add( 'b2c-settings-active' );
	}

	hideSettings() {
		document.documentElement.classList.remove( 'b2c-settings-active' );
	}

	closeAll() {
		document.documentElement.classList.remove( 'b2c-settings-active' );
		// setTimeout(e => {
		document.documentElement.classList.remove( 'b2c-popup-active' );
		// }, 200);

		if ( this.cookiePopup.dataset.reload === 'true' ) {
			window.location.reload();
		}
	}
}

const cookies = new CookiePopup();
setTimeout( ( e ) => {
	cookies.show();
}, 1000 );

window.b2Cookies = cookies;

if ( ( 'ontouchstart' in window ) ||
  ( navigator.maxTouchPoints > 0 ) ||
  ( navigator.msMaxTouchPoints > 0 ) ) {
	document.body.classList.add( 'b2c-mobile' );
}

